export const Types = {
    TASK_LIST: "TASK_LIST",
    IMMUNE_TASK_LIST: "IMMUNE_TASK_LIST",
  };